<template>

	<div class="index-video-block clearfix">

		<div class="row">
			<div class="col-md-12">
				<div class="index-title-block clearfix">
					<div class="pull-left index-title">
						<i class="fa fa-video-camera"></i>
						<span v-show="this.type === Type.COURSE">课程视频</span>
						<span v-show="this.type === Type.LECTURE">其他视频</span>


					</div>
					<div class="pull-right index-title-more">
							<span v-show="this.type === Type.COURSE" class="nb-a"
							      @click.stop.prevent="$router.push('/'+topic.location+'/resource/video')">
								更多
								<i class="fa fa-caret-square-o-right color-main"></i>
							</span>
						<span v-show="this.type === Type.LECTURE" class="nb-a"
						      @click.stop.prevent="$router.push('/'+topic.location+'/resource/lecture')">
								更多
								<i class="fa fa-caret-square-o-right color-main"></i>
							</span>

					</div>
				</div>
				<div class="index-content-block">

					<div class="row">
						<div v-for="video in pager.videos" class="col-md-12">
							<div class="img-block" :style="'background-image:url('+video.poster.url+')'"
							     @click.stop.prevent="video.click()">
								<i class="ml10 mt10 fa fa-play-circle-o white f30"></i>
							</div>
						</div>
					</div>


				</div>

			</div>
		</div>


	</div>


</template>


<script>


	import Pager from "../../../../../common/model/base/Pager";

	import Video from "../../../../../common/model/video/Video";


	export default {


		data() {
			return {
				pager: new Pager(Video, 1),
				Type: Video.prototype.Type
			};
		},
		props: {
			type: {
				type: String,
				required: false,
				"default": Video.prototype.Type.COURSE
			}
		},
		computed: {
			topic(){
				return this.$route.meta.topic;
			}
		},
		watch: {},
		methods: {

			refresh(){
				let that = this;

				this.pager.setFilter("type", this.type);
				this.pager.httpFastPage();

			}

		},
		mounted(){
			this.refresh();
		}
	};
</script>


<style lang="less" rel="stylesheet/less">
	@import "../../../../../common/assets/css/global/variables";

	.index-video-block {

		.img-block {
			height: 160px;
			background-position: center center;
			background-size: cover;
			background-repeat: no-repeat;
			cursor: pointer;

		}



	}
</style>




// WEBPACK FOOTER //
// IndexVideo.vue?53799cfe